import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import globalContext from "../../../Context/GlobalContext";
import HeaderMobile from "./HeaderMobile";
import MenuBar from "../Menubar/MenuBar";

export default function Header() {
  const contextData = useContext(globalContext);
  const [headerBgColor, setHeaderBgColor] = useState("transparent");
  const [isMenuBarOpen, setIsMenuBarOpen] = useState("");
  useEffect(() => {
    if (window.location.pathname === "/") {
      setHeaderBgColor("#FFF");
    } else {
    }
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        setHeaderBgColor("#FFFFFF");
      } else {
        setHeaderBgColor("");
      }
    });
  }, []);
  return (
    <>
      <div
        style={{ backgroundColor: `${headerBgColor}` }}
        className={`${
          !contextData?.isHeaderShown
            ? "hidden"
            : " fixed hidden min-[769px]:flex items-center justify-center top-0 left-1/2 -translate-x-1/2 w-full  h-[86px] z-30"
        } `}
      >
        <div className="w-full max-w-[1440px] flex items-center justify-between px-[20px]">
          <div className="w-[271px]  p-[10px] pr-[31px] gap-[10px] flex flex-col shrink-0 items-end justify-center ">
            <a href="/repair/links/app">
              <button className="w-[160px] h-[35px] flex items-center justify-center gap-[4px] shrink-0 rounded-[5px] bg-[#FFC100] px-[4px] py-[16px] ">
                <span className="text-[16px] font-font_primary_A font-semibold ">
                  نسخه اتوسرویس
                </span>
              </button>
            </a>
          </div>
          <div className="flex items-start gap-x-[24px]">
            <a href="/aboutUs">
              <span className="font-font_primary_A text-[16px] font-bold py-[4px] px-[12px] cursor-pointer text-color-primary-D">
                درباره ما
              </span>
            </a>
            <a href="/contactUs">
              <span className="font-font_primary_A text-[16px] font-bold py-[4px] px-[12px] cursor-pointer text-color-primary-D">
                تماس با ما
              </span>
            </a>
            <a href="/workWidthUs">
              <span className="font-font_primary_A text-[16px] font-bold py-[4px] px-[12px] cursor-pointer text-color-primary-D">
                همکاری با ما
              </span>
            </a>

            <a href="/">
              <span className="font-font_primary_A text-[16px] font-bold py-[4px] px-[12px] cursor-pointer text-color-primary-D">
                صفحه اصلی
              </span>
            </a>
          </div>
          <div className="w-[281px] p-[10px] gap-[10px] flex flex-col items-start justify-start shrink-0 ">
            <a href="/">
              <img
                src="/../assets/images/mainPage/img_logoTextEn.png"
                className="w-[215px] h-[45px] cursor-pointer"
              />
            </a>
          </div>
        </div>
      </div>
      <HeaderMobile setIsMenuBarOpen={setIsMenuBarOpen} />
      <MenuBar
        isMenuBarOpen={isMenuBarOpen}
        setIsMenuBarOpen={setIsMenuBarOpen}
      />
    </>
  );
}
